import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { NgbDateStruct, NgbDateParserFormatter, NgbDatepicker, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { CustomNgbDateParserFormatter } from '../../services/customDateParserFormatter.service';

@Component({
  selector: 'tr-date-picker',
  templateUrl: './date-picker.component.html',
  //styleUrls: ['./date-picker.component.scss'],
  providers: [NgbDatepickerConfig],
  host: {
    '(document: click)': 'onClickOutside($event)'
  }
})
export class DatePickerComponent extends FieldType implements OnInit {
  ngbModel: NgbDateStruct;
  @ViewChild('d') _ngbDatepicker;

  constructor(private parserFormatter: NgbDateParserFormatter, private _elementRef: ElementRef, dateConfig: NgbDatepickerConfig) {
    super();
    // Return today's date and time
    const currentTime = new Date();
    dateConfig.minDate = { year: 1900, month: 1, day: 1 };
    dateConfig.maxDate = { year: currentTime.getFullYear() + 10, month: currentTime.getMonth() + 1, day: currentTime.getDate() };
  }

  ngOnInit() {
    if (_.has(this.to, 'displayFormat')) {
      (<CustomNgbDateParserFormatter>this.parserFormatter).setDateFormat(this.to.displayFormat);
    }
    if (this.model[this.key]) this.ngbModel = this.toDateStruct(this.model[this.key]);
  }

  toDateStruct(str): NgbDateStruct {
    return this.parserFormatter.parse(str);
  }

  onSelectDate(date: NgbDateStruct) {
    if (date != null) {
      setTimeout(() => {
        const dateString = (<CustomNgbDateParserFormatter>this.parserFormatter).formatForServer(date); //`${date.year}-${date.month}-${date.day}`;
        const regExpression = this._isValidRegex(this.to['date_pattern']);
        if (regExpression.status && regExpression.regexp.test(dateString) ) {
          this.ngbModel = date;
          this.model[this.key] = dateString;
          if (_.has(this.formControl.errors, 'pattern') && _.size(this.formControl.errors.pattern)) {
            delete this.formControl.errors['pattern'];
            if (!_.size(this.formControl.errors)) {
              this.formControl.setErrors(null);
            }
          }
        } else {
          delete this.model[this.key];
          this.formControl.setErrors({ pattern: { actualValue: dateString, requiredPattern: this.to['date_pattern'] } });
        }
      });
    }
  }

  private _isValidRegex(str: string): any {
    const result = {
      status: false,
      regexp: null
    };

    try {
      result.regexp = new RegExp(str, 'gi');
      result.status = true;
    } catch (err) {
      result.regexp = null;
      result.status = false;
    }

    return result;
  }

  onClickOutside($event) {
    if (!this.isTargettingToggleButton($event)) {
      this._ngbDatepicker.close();
    }
  }

  private isTargettingToggleButton($event): boolean {
    return this._elementRef.nativeElement.contains($event.target);
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/components/date-picker/date-picker.component.ts